import api from 'services/api';
import { getCompanyContext } from 'utils/setCompanyContext';

class ComissaoPresetService {
  getEmpresaPadrao() {
    const ctx = getCompanyContext();
    return ctx?.companies?.[0]?.name || 'MOV Fibra';
  }

  async listar(empresa) {
    try {
      const response = await api.get('/comercial/comissao-presets', {
        params: { empresa: empresa || this.getEmpresaPadrao() },
      });
      return { success: true, data: response.data?.data ?? [] };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao listar presets',
        data: [],
      };
    }
  }

  async criar(dados) {
    try {
      const response = await api.post('/comercial/comissao-presets', {
        empresa: dados.empresa || this.getEmpresaPadrao(),
        nome: dados.nome,
        vendedor_nome: dados.vendedor_nome,
        colaborador_nome: dados.colaborador_nome,
        tipo: dados.tipo || 'comercial',
        ativo: dados.ativo !== undefined ? !!dados.ativo : true,
      });
      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao criar preset',
      };
    }
  }

  async atualizar(id, dados) {
    try {
      const response = await api.put(`/comercial/comissao-presets/${id}`, {
        empresa: dados.empresa || this.getEmpresaPadrao(),
        ...dados,
      });
      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao atualizar preset',
      };
    }
  }

  async remover(id, empresa) {
    try {
      await api.delete(`/comercial/comissao-presets/${id}`, {
        params: { empresa: empresa || this.getEmpresaPadrao() },
      });
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao remover preset',
      };
    }
  }
}

const comissaoPresetService = new ComissaoPresetService();
export default comissaoPresetService;
